import React from 'react'
import style from './info.module.css'
const Info = () => {
  return (
    <div className={style.container}>
      <div className={style.box}>
      <h1 className={style.heading}>About Me ....</h1>
      <p className={style.text}>Hello! My name is Dinesh Singh Bisht and I enjoy creating things that live on the internet.
      My interest in web development started back in 2020 when I started learning HTML and CSS.
      I had a blast learning the basics of web development and I immediately fell in love with it.
      I decided to turn my interest into a career path by enrolling in a coding bootcamp.
      
      

      </p>
      </div>
    </div>
  )
}

export default Info